import { kebabCase } from '@ampcore/string-format'

export function createAlertId(str: string) {
  return kebabCase(str).substring(0, 500)
}
